import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Inject, OnInit, Output, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { NotificationService } from '../../../services/notificationservice';
import {
  FeedStockLoadDocumentResponse,
  ViewDocumentsDialogData,
} from '../../../interfaces/pricematrixmodel';
import {
  ConfirmationDialogData,
  ConfirmationDialogComponent,
} from '../../shared/components/confirmation-dialog/confirmation-dialog.component';
import { MatCardContent, MatCardModule } from '@angular/material/card';
import { AppDialogComponent } from '../../common/app-dilaog/app-dialog.component';
import { HaulerService } from '../../../services/haulerservice';
import { DialogService } from '../../../services/dialogservice';
import { SiteService } from '../../../services/siteservice';
import { FeedstockService } from '../../../services/feedstockservice';
import { DragDropModule } from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-view-documents',
  imports: [
    CommonModule,
    MatDialogModule,
    MatTableModule,
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    DragDropModule
  ],
  templateUrl: './view-documents.component.html',
  styleUrl: './view-documents.component.scss',
})
export class ViewDocumentsComponent implements OnInit {
  displayedColumns: string[] = ['actions', 'id', 'name', 'type'];
  dialogTitle = '';
  documents: FeedStockLoadDocumentResponse[] = [];
  loadScheduleId: number;
  isDelete= signal(false);
  screenTypeId: number = 0;
  @Output('onFormSubmit') formEmitter = new EventEmitter<any>();
  canShowGridActions: boolean = false;

  constructor(
    private _dialog: MatDialog,
    public dialogRef: MatDialogRef<ViewDocumentsComponent>,
    private dialog: MatDialog,
    private haulerService: HaulerService,
    private dialogService: DialogService,
    private notificationService: NotificationService,
    @Inject(MAT_DIALOG_DATA) public data: ViewDocumentsDialogData,
    private siteService: SiteService,
    private feedstockService: FeedstockService
  ) {
    this.loadScheduleId = data.loadScheduleId;
    this.screenTypeId = 2;
    this.dialogTitle = `View Document: ${data.name}`;
    this.canShowGridActions = data.canShowGridActions;
  }

  ngOnInit(): void {
    this.getDocuments();
  }

  getDocuments(): void {
    this.siteService
      .getDocuments(this.loadScheduleId, this.screenTypeId)
      .subscribe({
        next: (data: FeedStockLoadDocumentResponse[]) => {
          console.log('docs data', data);
          this.documents = data;
        },
      });
  }

  onDownloadDocument(element: FeedStockLoadDocumentResponse): void {
    if (!element || !element.name || !element.blobID || element.docTypeId === undefined) {
      return;
    }

    this.feedstockService.downloadDocument(element).subscribe({
      next: (response: Blob) => {
        // Create a temporary URL to download the blob
        const downloadUrl = window.URL.createObjectURL(response);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = element.name ?? '';
        link.click();
        
        window.URL.revokeObjectURL(downloadUrl);
      }
    });
  }

  onViewDocument(document: FeedStockLoadDocumentResponse): void {
    const downloadUrl = `/FeedStock/DownloadDocument?fileName=${document.name}&blobId=${document.blobID}&docTypeId=${document.docTypeId}`;
    window.open(downloadUrl, '_blank');
  }

  deleteHaulerRecord(data: FeedStockLoadDocumentResponse) {
    const dialogRef = this._dialog.open(AppDialogComponent, {
      width: '500px',
      data: {
        title: 'Delete',
        message: 'Are you sure you want to delete record? ',
        styles: {
          message: {
            color: 'gray',
          },
        },
        actions: ['OK', 'CANCEL'],
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result?.confirm) {
        console.log('delete record:', data);
        this.handleDeleteSiteDocument(data);
      }
    });
  }

  handleDeleteSiteDocument(data: FeedStockLoadDocumentResponse) {
    this.siteService
      .deleteDocument(String(data.name ?? ''), String(data.blobID ?? ''), data.docTypeId ?? 0)
      .subscribe({
        next: (response: any) => {
          //this.dialogRef.close(true);
          this.formEmitter.emit({ submit: true });
          this.notificationService.show(
            'Hauler deleted successfully',
            'success'
          );
          this.getDocuments();
          this.isDelete.set(true);
        },
      });
  }

  onDeleteDocument(document: FeedStockLoadDocumentResponse): void {
    const dialogData: ConfirmationDialogData = {
      title: 'Confirm Deletion',
      message: `Are you sure you want to delete document ${document.name}?`,
      confirmButtonText: 'Delete',
      cancelButtonText: 'Cancel',
      confirmButtonColor: 'warn',
    };

    this.dialog
      .open(ConfirmationDialogComponent, {
        width: '400px',
        panelClass: 'delete-confirmation-dialog',
        data: dialogData,
        disableClose: true,
      })
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          this.getDocuments();
        }
      });
  }

  onClose(): void {
    let result = this.isDelete()
    this.dialogRef.close(result);
  }
}
